import * as React from 'react';

interface Props {
  dataTestId: string;
  isMobile: boolean;
}

const ContactIcon = ({ dataTestId, isMobile }: Props) => (
  <svg
    data-testid={dataTestId}
    width={isMobile ? '200px' : '256px'}
    height={isMobile ? '160px' : '205px'}
    viewBox="0 0 200 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="160" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.4001 107.199H123.2C123.612 107.199 124.014 107.155 124.4 107.07C124.787 107.155 125.188 107.199 125.6 107.199H167.2C170.293 107.199 172.8 104.692 172.8 101.599C172.8 98.5064 170.293 95.9992 167.2 95.9992H162.4C159.307 95.9992 156.8 93.492 156.8 90.3992C156.8 87.3064 159.307 84.7992 162.4 84.7992H177.6C180.693 84.7992 183.2 82.292 183.2 79.1992C183.2 76.1064 180.693 73.5992 177.6 73.5992H160C163.093 73.5992 165.6 71.092 165.6 67.9992C165.6 64.9064 163.093 62.3992 160 62.3992H108.8C111.893 62.3992 114.4 59.892 114.4 56.7992C114.4 53.7064 111.893 51.1992 108.8 51.1992H63.2001C60.1073 51.1992 57.6001 53.7064 57.6001 56.7992C57.6001 59.892 60.1073 62.3992 63.2001 62.3992H31.2001C28.1073 62.3992 25.6001 64.9064 25.6001 67.9992C25.6001 71.092 28.1073 73.5992 31.2001 73.5992H51.2001C54.2929 73.5992 56.8001 76.1064 56.8001 79.1992C56.8001 82.292 54.2929 84.7992 51.2001 84.7992H19.2001C16.1073 84.7992 13.6001 87.3064 13.6001 90.3992C13.6001 93.492 16.1073 95.9992 19.2001 95.9992H50.4001C47.3073 95.9992 44.8001 98.5064 44.8001 101.599C44.8001 104.692 47.3073 107.199 50.4001 107.199ZM180.8 107.199C183.893 107.199 186.4 104.692 186.4 101.599C186.4 98.5064 183.893 95.9992 180.8 95.9992C177.707 95.9992 175.2 98.5064 175.2 101.599C175.2 104.692 177.707 107.199 180.8 107.199Z"
      fill="#F3F7FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M134.861 99.9591C132.8 101.582 130.79 103.107 128.515 104.425L128.647 116.295C128.657 117.225 127.949 117.989 127.066 118C126.706 118.004 126.356 117.881 126.071 117.65L115.941 109.439C112.144 110.36 108.139 110.853 104 110.853C79.6995 110.853 60 93.8724 60 72.9263C60 51.9802 79.6995 35 104 35C128.301 35 148 51.9802 148 72.9263C148 78.7237 146.491 84.2174 143.793 89.1312C143.295 90.0375 142.757 90.924 142.181 91.7891C142.181 91.7891 141.054 93.575 138.8 96.1035C136.546 98.6319 134.861 99.9591 134.861 99.9591Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M134.861 99.9591C132.8 101.582 130.79 103.107 128.515 104.425L128.647 116.295C128.657 117.225 127.949 117.989 127.066 118C126.706 118.004 126.356 117.881 126.071 117.65L115.941 109.439C112.144 110.36 108.139 110.853 104 110.853C79.6995 110.853 60 93.8724 60 72.9263C60 51.9802 79.6995 35 104 35C128.301 35 148 51.9802 148 72.9263C148 78.7237 146.491 84.2174 143.793 89.1312C143.295 90.0375 142.757 90.924 142.181 91.7891C142.181 91.7891 141.054 93.575 138.8 96.1035C136.546 98.6319 134.861 99.9591 134.861 99.9591Z"
      stroke="#5C92FF"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M130.411 62.9912C134.676 62.9912 138.782 62.4642 142.629 61.489C144.164 65.1137 145 69.0194 145 73.0895C145 78.3693 143.594 83.3725 141.08 87.8476C140.616 88.673 140.115 89.4803 139.577 90.2682C138.729 91.5122 138.125 92.3906 137.592 93.0949C136.333 94.7612 135.477 95.4537 132.757 97.7087C130.943 99.2127 128.964 100.576 126.844 101.776L126.966 112.586C126.976 113.433 127.225 114.99 126.401 115C126.067 115.004 124.832 114.031 124.567 113.82L116.359 106.222C112.82 107.061 107.857 107.63 104 107.63C81.3563 107.63 63 92.1655 63 73.0895C63 57.4675 75.3107 44.2679 92.2051 40C96.6298 53.2288 112.058 62.9912 130.411 62.9912Z"
      fill="#E8F0FE"
    />
    <path
      d="M71.8803 59C71.1539 60.2255 70.5244 61.4974 70 62.8088"
      stroke="#75A4FE"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M86.8662 46C81.624 48.5019 77.1983 52.0409 74 56.2776"
      stroke="#75A4FE"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M100.236 80.0437L100.236 80.0437L100.233 80.0566C100.182 80.2967 100.137 80.5468 100.098 80.8066C99.8135 82.7289 101.43 84.193 103.182 84.193C105.004 84.193 106.243 82.722 106.658 81.2599C106.686 81.1602 106.717 81.0633 106.749 80.9692C106.949 80.3907 107.347 79.8042 108.002 79.2176L108.018 79.2031C108.878 78.3964 109.68 77.5946 110.424 76.7977C111.209 75.9563 111.847 75.0444 112.331 74.0619L112.333 74.0573C112.843 73.0081 113.087 71.8423 113.087 70.5781C113.087 68.8502 112.722 67.3169 111.946 66.0181C111.183 64.7181 110.07 63.7396 108.642 63.0829C107.231 62.4149 105.571 62.1 103.691 62.1C101.97 62.1 100.387 62.4056 98.9574 63.0341C97.503 63.6602 96.3315 64.6228 95.4647 65.9148C95.0809 66.4811 94.7801 67.1044 94.5596 67.7802C94.2217 68.8158 94.5277 69.8003 95.1531 70.4913C95.7643 71.1668 96.6835 71.5758 97.6586 71.5758H98.09C98.9551 71.5758 99.6537 71.193 100.19 70.7241C100.716 70.2634 101.134 69.6794 101.461 69.1693L101.461 69.1693L101.466 69.1606C101.704 68.7811 102.002 68.5185 102.371 68.3478C102.784 68.1564 103.221 68.0602 103.691 68.0602C104.306 68.0602 104.741 68.1811 105.048 68.3634C105.056 68.3683 105.064 68.373 105.072 68.3776C105.393 68.5546 105.634 68.8112 105.805 69.1792L105.812 69.1954C105.996 69.5721 106.112 70.0915 106.112 70.793C106.112 71.3752 106 71.8678 105.795 72.2889C105.566 72.7445 105.244 73.1988 104.816 73.6501L104.815 73.6506C104.361 74.1298 103.841 74.6442 103.253 75.1941L103.253 75.1941L103.248 75.1985C102.455 75.9508 101.805 76.7079 101.315 77.4717C100.811 78.243 100.453 79.1031 100.236 80.0437ZM100.485 86.7699L100.485 86.7698L100.477 86.7777C99.7762 87.4783 99.432 88.3633 99.432 89.3672C99.432 90.3543 99.7825 91.2233 100.477 91.9176L100.477 91.9177L100.485 91.9255C101.22 92.6429 102.18 92.9625 103.262 92.9625C104.341 92.9625 105.298 92.6442 106.023 91.9216C106.73 91.2296 107.091 90.3597 107.091 89.3672C107.091 88.3581 106.737 87.4721 106.023 86.7737C105.298 86.0511 104.341 85.7328 103.262 85.7328C102.18 85.7328 101.22 86.0525 100.485 86.7699Z"
      fill="white"
      stroke="#5C92FF"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M141.44 31.1992V35.0392"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M141.44 40.1602V44.0002"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M135.04 37.598H138.88"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M144 37.598H147.84"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.7201 107.199V109.759"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.7201 114.879V117.439"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.6001 112.321H52.1601"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.28 112.321H59.84"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ContactIcon;
